import React from "react";

import AllRoutes from "./routes/Routes";

import { configureFakeBackend } from "./helpers";

import { ToastProvider } from "./components/ToastContext";

import { PopupProvider } from "./components/PopupContext";

// import { GlobalStateProvider } from "./components/GlobalStateContext";

import { LocalStorageProvider } from "./hooks/localStorageContext";

// Themes
// For Default import Theme.scss
import "./assets/scss/Theme.scss";

// For Dark import Theme-Dark.scss
// import './assets/scss/Theme-Dark.scss';

// configure fake backend
configureFakeBackend();

const App = () => {
  return (
    <>
      <React.Fragment>
        {/* <GlobalStateProvider> */}
        <ToastProvider>
          <LocalStorageProvider>
            <PopupProvider>
              <AllRoutes />
            </PopupProvider>
          </LocalStorageProvider>
        </ToastProvider>
        {/* </GlobalStateProvider> */}
      </React.Fragment>
    </>
  );
};

export default App;
